import Axios from "@/plugins/Axios";

export class PlanosMensaisInfantil {
  async planoMensal(gestaoDeAulaId, mes_id) {
    const response = await Axios().get(
      `planos-mensais-infantil/plano-mensal/${gestaoDeAulaId}/${mes_id}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-mensais-infantil/criar-plano-mensal`, {
      plano,
    });
    return response.data;
  }

  async planoMensalPDF(gestaoDeAulaId, mes, file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await Axios().post(
      `planos-mensais-infantil/uploadPdf/${gestaoDeAulaId}/${mes}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const resultData = response.data ?? response;
    if (resultData) {
      return resultData;
    }

    return null;
  }

  async planoMensalDownload(gestaoDeAulaId, mes) {
    const response = await Axios()
      .get(`planos-mensais-infantil/downloadPdf/${gestaoDeAulaId}/${mes}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }

  async removerPlanoMensal(gestaoDeAulaId, mes) {
    const response = await Axios().delete(
      `planos-mensais-infantil/remover-plano-mensal/${gestaoDeAulaId}/${mes}`
    );
    return response.data;
  }
}

export default new PlanosMensaisInfantil();
